import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=833bdfb6&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./banner.scss?vue&type=style&index=0&id=833bdfb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833bdfb6",
  null
  
)

export default component.exports